import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Paths
import { Heart } from './IconPaths';

class HeartIcon extends React.Component {
  constructor(props) {
    super(props);

    this._icon = null;
  }
  _initAnimations() {
    TweenMax.to(this._icon, 0.2, {
      scale: 1.1,
      transformOrigin: '50% 50%',
      ease: Power2.easeInOut,
      repeat: 10,
      yoyo: true
    });
  }
  componentDidMount() {
    this._initAnimations();
  }
  render() {
    const { color, height, width } = this.props;
    return (
      <svg viewBox='0 0 100 100' width={width} height={height}>
        <g ref={icon => { this._icon = icon; }}>
          <Heart strokeColor={color} transform={'translate(0, 0)'} />
        </g>
      </svg>
    );
  }
};

HeartIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

HeartIcon.defaultProps = {
  color: 'black',
  width: 200,
  height: 200
};

export default HeartIcon;



// WEBPACK FOOTER //
// ./src/components/AnimatedIcons/HeartIcon.jsx